import { useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import RootState from "../../../redux/type";
import { getRemittanceRulesHistory } from "../../../redux/featureMgt";
import { RazorTable, RazorTableRow } from "../../../components/razor-reuse";
import { formatTime } from "../../../utils/Helper";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";

export default function ACHNowManagementDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const cust_id = localStorage?.getItem("cors_key") || "";

  const { loading, remittance_rules_history } = useSelector(
    (state: RootState) => state.feature_mgt
  );

  const headerList = [
    "Minimum Limit",
    "Maximum Limit",
    "Remittance thresholds",
    "Updated By",
    "Date & Time",
  ];

  useEffect(() => {
    if (cust_id) {
      // fetch details of the customer using cust_id
      const payload = {
        id: cust_id,
        param: {
          page,
        },
      };
      dispatch(getRemittanceRulesHistory(payload) as any);
    } else {
      navigate(ALL_ROUTES?.DASHBOARD_FEATURE_MANAGEMENT);
    }
  }, [dispatch]);

  return (
    <DashboardLayoutMain
      back
      onBack={() => navigate(-1)}
      loading={false}
      title="Feature Management"
    >
      <section className="px-[2rem] space-y-4 mt-[15px] pb-[40px]">
        <div className="bg-white py-[16px] px-[30px] flex items-center mb-[28px]">
          <p className="font-semibold text-[18px] text-[#252C32]">
            ACHNow Management History Page
          </p>
        </div>
        <section className="pt-[30px]">
          <RazorTable tableStrip={true} headerList={headerList}>
            {remittance_rules_history?.data?.map((chi: any) => {
              return (
                <RazorTableRow
                  loading={loading}
                  key={chi?.id}
                  one={chi?.min_spend ? `$${chi?.min_spend}` : "---"}
                  two={chi?.max_spend ? `$${chi?.max_spend}` : "---"}
                  three={
                    chi?.smartsend_remit ? `$${chi?.smartsend_remit}` : "---"
                  }
                  four={`${chi?.updated_by?.first_name} ${chi?.updated_by?.last_name}`}
                  five={formatTime(chi?.updated_at)}
                />
              );
            })}
          </RazorTable>
          {(remittance_rules_history?.data?.length ?? 0) < 1 && !loading && (
            <section className="size-full bg-white h-[300px] grid place-content-center">
              <figure className="size-fit mx-auto space-y-[8px]">
                {ALL_ICONS.receipt_warning}
              </figure>
              <p className="text-[12px] text-gray-02">No table records found</p>
            </section>
          )}
          <PaginationFragment
            currentPage={remittance_rules_history?.meta?.current_page || 1}
            perPage={remittance_rules_history?.meta?.per_page}
            totalPage={remittance_rules_history?.meta?.total}
            onPageChange={(num) => {
              setPage(num);
            }}
            hidePagination={loading}
          />
        </section>
      </section>
    </DashboardLayoutMain>
  );
}
